import React, { ReactElement, useRef } from 'react'
import { AuthSession } from '../core/AuthSession/AuthSession'

const AuthSessionContext = React.createContext<null | AuthSession>(null)

export const AuthSessionProvider = (props: {
   getAuthSession: () => AuthSession
   children: ReactElement
}) => {
   const { children, getAuthSession } = props

   const authSessionRef = useRef(getAuthSession())

   return (
      <AuthSessionContext.Provider value={authSessionRef.current}>
         {children}
      </AuthSessionContext.Provider>
   )
}

export const useAuthSession = () => {
   const context = React.useContext(AuthSessionContext)

   if (!context) {
      throw new Error('Expected to be wrapped in CookieAuthSessionProvider')
   }

   return {
      getAccessToken: context.getAccessToken,
      clearAccessTokenCookie: context.clearAccessToken,
      clearAllCookies: context.clearSessionDetails
   }
}

export const useSetSessionDetails = () => {
   const context = React.useContext(AuthSessionContext)

   if (!context) {
      throw new Error('Expected to be wrapped in Cookie Auth Session Provider')
   }

   return context.setSessionDetails
}
